import dashboardVariantSelector from './dashboardVariantSelector';
import refreshCounterSelector from './refreshCounterSelector';
import userSelector from './userSelector';
import * as dashboardTabSelector from './dashboardTabSelector';

const allSelectors = {
    dashboardVariantSelector,
    refreshCounterSelector,
    userSelector,
    dashboardTabSelector
};

export default allSelectors;